<template>
  <div
    id="logo"
    class="d-flex align-items-center"

    :style="`width: ${width}px`"
  >
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 268 78" width="268" height="78" :fill="color">
      <path id="svg_1" d="m0,19.14l38.35,0l0,19.35l-19,0l0,19.35l19.29,0l0,-19.14l19.35,0l0,19.35l-19.29,0l0,19.14l-38.7,0l0,-19.35l0,0l0,-38.7zm38.64,-19.14l19.35,0l0,38.7l-19.35,0l0,-38.7" />
      <path id="svg_2" d="m0,0zm87.07,31.98l8.9,0c6.41,0 10.81,3.86 10.81,9.8c0,5.93 -4.4,9.8 -10.81,9.8l-8.9,0l0,-19.6zm8.68,15.87c3.89,0 6.44,-2.32 6.44,-6.07c0,-3.75 -2.55,-6.08 -6.44,-6.08l-4.15,0l0,12.15" />
      <path id="svg_3" d="m6.950579461191178,47.85 zm126.21,0.09000000000000036 l0,3.64 l-15.17,0 l0,-19.6 l14.81,0 l0,3.64 l-10.31,0 l0,4.25 l9.1,0 l0,3.5300000000000002 l-9.1,0 l0,4.54 " />
      <path id="svg_4" d="m13.401162922382357,47.94 zm145.84,0 l0,3.64 l-15.17,0 l0,-19.6 l14.81,0 l0,3.64 l-10.31,0 l0,4.25 l9.1,0 l0,3.5300000000000002 l-9.1,0 l0,4.54 " />
      <path id="svg_5" d="m20.101744383573532,47.94 zm167.29,-8.85 c0,4.37 -3.2800000000000002,7.08 -8.51,7.08 l-3.95,0 l0,5.41 l-4.54,0 l0,-19.6 l8.49,0 c5.23,0 8.51,2.71 8.51,7.11 zm-4.59,0 c0,-2.16 -1.4,-3.42 -4.17,-3.42 l-3.7,0 l0,6.8100000000000005 l3.7,0 c2.77,0 4.17,-1.26 4.17,-3.39 zm8.65,-39.09 " />
      <path id="svg_6" d="m26.80232584476471,39.09 zm171.35,-7.11 l4.53,0 l0,19.6 l-4.53,0 l0,-51.58 " />
      <path id="svg_7" d="m33.50290730595589,31.98 zm185.91,3.64 l0,5.18 l9.07,0 l0,3.64 l-9.07,0 l0,7.14 l-4.54,0 l0,-19.6 l14.82,0 l0,3.64 " />
      <path id="svg_8" d="m40.203488767147064,35.62 zm209.51,9.01 l0,6.95 l-4.53,0 l0,-7 l-7.59,-12.6 l4.82,0 l5.23,8.71 l5.24,-8.71 l4.45,0 l-7.62,12.65 z" />
    </svg>
    <!-- eslint-enable -->
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 128,
    },
    color: {
      type: String,
      default: '#444444',
    },
  },
};
</script>
<style scoped>
  #logo svg {
    width: 100%;
    height: auto;
  }
</style>
